export const userRoles = {
    user: 'OB',
    orgAdmin: 'OA',
    sysAdmin: 'SA'
};